// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"map_loaderContainer__2envz","loaderText":"map_loaderText__1Bqef"};